<div class=" mt-4">
  <section>
      <div class="scrollmenu">
          <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
          <a [routerLink]="['/pos/customer/new']"> Customer </a>
          <a [routerLink]="['/pos/Employee/new']"> Employee </a>
          <a [routerLink]="['/pos/orders/new']"> Orders</a>
          <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
          <a [routerLink]="['/pos/category/new']"> Item-Category </a>
          <a [routerLink]="['/pos/item/new']"> Items </a>
          <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
          <!-- <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/order/new']"> Order </a>
          <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
          <a [routerLink]="['/pos/payment/new']"> Payment </a>
          <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
          <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

          <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
          <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
          <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
      </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
               
              <div class="col-md-7">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                            
                              <div class="text-center">
                                  <!-- <a class="view-h gary-t mb-3">Order</a> -->
                                  <div class="col-md-12" *ngIf="isNeworder">
                                    <h4  class="font20 gary-t pt-3">Lets create a Order</h4>
                                  </div>
                                  <div class="col-md-12" *ngIf="isUpdateorder">
                                    <h4  class="font20 gary-t pt-3">Lets Update an Order </h4>
                                  </div>
                                  <div class="col-md-12" *ngIf="vieworder">
                                    <h4  class="font20 gary-t pt-3">view order </h4>
                                  </div>
                                 
                              </div>

                              <div class="py-3">
                                <form #fnebusiness="ngForm">
                                  <div class="row mx-0">
                                    <!-- New Order starts -->
                                    <div class="col-md-12" *ngIf="isNeworder">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                                          <div class="row pt-2">
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Automatic Group Similar Items</label>
                                            </div>
                                            
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="AutoMaticGroupSimilarItmes"
                                                  id="AutoMaticGroupSimilarItmes" name="AutoMaticGroupSimilarItmes" (click)="showhide()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Allow Notes On Orders</label>
                                            </div>
                                            
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="AllowNotesOnOrders" id="AllowNotesOnOrders"
                                                  name="AllowNotesOnOrders" (click)="showhide1()" />
                                              </div>
                                            </div>
                                          </div>
                      
                      
                      
                      
                      
                      
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="btnSaveOrder" color="primary" [disabled]=""
                                              (click)="newOrder()">Submit</button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                    <!-- order Update starts -->
                                    <div class="col-md-12" *ngIf="isUpdateorder">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                      
                                          <div class="row pt-2">
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Automatic Group Similar Items</label>
                                            </div>
                                            
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="AutoMaticGroupSimilarItmes"
                                                  id="AutoMaticGroupSimilarItmes" name="AutoMaticGroupSimilarItmes" (click)="showhide()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Allow Notes On Orders</label>
                                            </div>
                                            
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="AllowNotesOnOrders" id="AllowNotesOnOrders"
                                                  name="AllowNotesOnOrders" (click)="showhide1()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <input type="hidden" [(ngModel)]="rows.Id" id="id" name="id" [formControl]="id">
                      
                                          <div class="text-right pt-3">
                                            <!-- <button class=" btn dash-btns" color="primary" [routerLink]="['/pos/order/manage',{}]" matTooltip="go back to List">Cancel</button> -->
                      
                                            <button class="btn dash-btns" type="button" id="btnUpdateOrder" [disabled]="" color="primary"
                                              (click)="updateOrder()">Update</button>
                                          </div>
                      
                                        </div>
                                      </form>
                      
                                    </div>
                                    <!-- view order -->
                                    <div class="col-md-12" *ngIf="vieworder">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                      
                                          <div class="row pt-2">
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Automatic Group Similar Items</label>
                                            </div>
                                            
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="AutoMaticGroupSimilarItmes"
                                                  id="AutoMaticGroupSimilarItmes" name="AutoMaticGroupSimilarItmes" >
                                              </div>
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Allow Notes On Orders</label>
                                            </div>
                                            
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                      
                                                <input type="checkbox" [(ngModel)]="AllowNotesOnOrders" id="AllowNotesOnOrders"
                                                  name="AllowNotesOnOrders" >
                                              </div>
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="text-right pt-3">
                                            <!-- <button class=" btn dash-btns" color="primary" [routerLink]="['/pos/order/manage',{}]" matTooltip="go back to List">Cancel</button> -->
                      
                                            <button class="btn dash-btns" type="button" id="btnUpdateOrder" color="primary"
                                              (click)="editorder()">Edit</button>
                                          </div>
                      
                                        </div>
                                      </form>
                                    </div>
                                    
                      
                                    </div> 
                                 
                                </form>

                                

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-5">
                <div class="text-center mb-5">
                  <img src="assets/img/new/pos.svg" />
              </div>
              </div>
          </div>
      </div>
  </section>

</div>








<!-- 




<section  >
  <div class="block-header">
    <div class="">
      <div class="row ">
        <div class="col-md-12  p-0">
          <h2 class="poppins font-weight-bold pl-2"> Order </h2>
        </div>
        <div class=" col-md-5 px-6 col-sm-12 p-0">

          <div class="breadcrumb flat">
            <a [routerLink]="['/pos']">  Home </a>
            <a href="#" class="active">Order</a>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
          <div class="row mx-0">
           
          </div>
          
        </div>
      </div>
    </div>
  </div>
</section> -->